import SingleLanguage from '../enums/single-language';
import { AccessLevel } from './pages-entities';

export type Auth0Provider = 'Google' | 'Microsoft' | 'auth0';

export interface Contact {
  contact_id: string;
  company_id: string;
  first_name: string;
  last_name: string;
  email?: string;
  title?: string;
  phone?: string;
  ext?: string;
  preferred_language?: SingleLanguage;
  gender?: string;
  roles?: string;
  comments?: string;
  auth_id?: string;
  auth0_provider?: Auth0Provider;
  created_at?: string;
  last_login_at?: string;
  updated_at?: string;
  auth_id_match?: boolean;
  hubspot_url?: string;
  crm_id?: string;
  subscribed_grant_notificiation_at?: Date;
  subscribed_newsletter_at?: Date;
  subscribed_grant_digest_at?: Date;
  access_type?: AccessLevel;
  terms_and_conditions_at?: Date;
  /**
   * Whether a document-request email would reach this contact and be worth sending.
   * Decided by the server, never here: the rule is one Go method, and a browser that
   * re-derives it from the fields above is a second answer waiting to disagree.
   */
  can_receive_document_request?: boolean;
  document_request_delivery_mode?: 'authenticated' | 'upload_only';
}

export type ContactPatch = Partial<
  Pick<
    Contact,
    | 'title'
    | 'first_name'
    | 'last_name'
    | 'email'
    | 'phone'
    | 'ext'
    | 'preferred_language'
    | 'gender'
    | 'comments'
    | 'auth_id'
    | 'company_id'
  >
>;

export const ContactInitialState: Contact = {
  contact_id: '',
  company_id: '',
  first_name: '',
  last_name: '',
};

export interface LinkedCompanyContactGroup {
  contacts: Contact[];
  company_name: string;
  company_id: string;
}

export interface Client {
  company_id: string;
  name: string;
  website: string;
  size: string;
  contacts: Contact[];
  city?: string;
}
